import React, { useState, useEffect } from 'react';
import ChargerSiteCard from '../chargerSiteCard/ChargerSiteCard';
import { useNavigate } from 'react-router-dom';
import { useLocationContext } from '../../context/LocationContext';
import { useBrandContext } from '../../context/BrandContext';
import { getFile } from '../../services/chargerSitesServices';
import { googleMapsSearchUrl, isInformationalSite } from '../../utils/sitePinType';

type ChargerSiteCardListProps = {
  chargerSites: any[];
};

const ChargerSitesList: React.FC<ChargerSiteCardListProps> = (
  chargerSitesProps
) => {
  const navigate = useNavigate();
  const locationContext = useLocationContext();
  const brandContext = useBrandContext();

  const [appBgFile, setAppBgFile] = useState<string | null>(null);
  const [loadingAppBgFile, setLoadingAppBgFile] = useState(true);

  function navigateToCharger(chargerSite: any) {
    // Local apenas informativo não tem tela de detalhes: o card leva direto à rota no mapa
    if (isInformationalSite(chargerSite)) {
      window.open(
        googleMapsSearchUrl(chargerSite.csLocation.coordinates[1], chargerSite.csLocation.coordinates[0]),
        '_blank',
        'noopener'
      );
      return;
    }
    navigate(`charger/${chargerSite.csId}?dist=${chargerSite.distanceMeters}`, {
      state: { chargerSiteInfos: chargerSite },
    });
  }

  const fetchBgFile = async (fileId: string) => {
    setLoadingAppBgFile(true);
    try {
      if (!fileId) return null;
      const csBgFile = await getFile(fileId);
      return csBgFile?.fileData;
    } catch (error) {
      console.error('Erro ao buscar sites de carregamento', error);
    } finally {
      setLoadingAppBgFile(false);
    }
  };

  useEffect(() => {
    const asyncHandler = async () => {
      const bgFile = await fetchBgFile(brandContext.appBgFileId);
      setAppBgFile(bgFile);
    };
    asyncHandler();
  }, [brandContext.appBgFileId]);

  return (
    <div className='charger-sites-list'>
      {chargerSitesProps.chargerSites.map((chargerSite) => (
        <ChargerSiteCard
          key={chargerSite.csId}
          chargerSite={chargerSite}
          appBgFile={appBgFile}
          loadingAppBgFile={loadingAppBgFile}
          userDistance={locationContext.getUserDistance(
            {
              lat: chargerSite.csLocation.coordinates[1],
              lng: chargerSite.csLocation.coordinates[0],
            },
            'km',
            1
          )}
          onClick={() => navigateToCharger(chargerSite)}
        />
      ))}
    </div>
  );
};

export default ChargerSitesList;
